import React from 'react';
import Navigator from './navigation/Navigator';

function App() {
  return <Navigator />;
}

export default App;
